import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { canvasArtworks } from "../data/canvasArtworks";
import { aboutCanvasFeaturedIds } from "../data/homepagePicks";
import { artworkPagePath } from "../lib/artworkPaths";
import { CanvasGalleryCard } from "./CanvasArtworkCards";

const HUNGRU_URL = "https://hungru.co";

function HungruLink({ children }: { children?: React.ReactNode }) {
  return (
    <a
      href={HUNGRU_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="font-medium text-accent underline-offset-2 hover:underline"
    >
      {children}
    </a>
  );
}

export function AboutBio() {
  const { t } = useTranslation();

  return (
    <div className="space-y-4 whitespace-pre-line leading-relaxed text-canvas-600">
      <p>{t("about.paragraph1")}</p>
      <p>{t("about.paragraph2")}</p>
      <p>
        <Trans
          i18nKey="about.paragraph3"
          components={{
            hungruLink: <HungruLink />,
          }}
        />
      </p>
      <p>{t("about.paragraph4")}</p>
    </div>
  );
}

export function AboutCanvasSection() {
  const { t } = useTranslation();
  const featured = aboutCanvasFeaturedIds
    .map((id) => canvasArtworks.find((w) => w.id === id))
    .filter((w): w is (typeof canvasArtworks)[number] => Boolean(w));

  return (
    <section className="border-t border-canvas-200/60 py-16 sm:py-20">
      <div className="section-container">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-medium uppercase tracking-[0.15em] text-accent">
            {t("about.canvas.eyebrow")}
          </p>
          <h2 className="mt-2 font-display text-3xl font-semibold text-canvas-950 sm:text-4xl">
            {t("about.canvas.title")}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-canvas-600">
            {t("about.canvas.description")}
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((work) => (
            <CanvasGalleryCard
              key={work.id}
              work={work}
              to={artworkPagePath("canvas", work.id)}
              className="mb-0"
            />
          ))}
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Link to="/gallery?tab=canvas" className="btn-primary !text-xs">
            {t("about.canvas.ctaGallery")}
          </Link>
          <Link to="/contact#commission" className="btn-secondary !text-xs">
            {t("about.canvas.ctaCommission")}
          </Link>
        </div>
      </div>
    </section>
  );
}
